import React from 'react';
import {Result} from "antd";
import {t} from "i18next";

export default function Forbidden() {
  return (
    <Result
      status="403"
      title="403"
      subTitle={t('errors.forbidden')}
    />
)
}
